import { render, staticRenderFns } from "./modalimporPTTMDT.vue?vue&type=template&id=4835e9db&scoped=true"
import script from "./modalimporPTTMDT.vue?vue&type=script&lang=js"
export * from "./modalimporPTTMDT.vue?vue&type=script&lang=js"
import style0 from "./modalimporPTTMDT.vue?vue&type=style&index=0&id=4835e9db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4835e9db",
  null
  
)

export default component.exports